module.exports = __webpack_public_path__ + "img/chongdian.074b7368.png";